__webpack_require__.p = "/Prompt-Generator/";